import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface StyleProps {
  primaryColor: string;
  secondaryColor: string;
}

const useStyles = makeStyles<Theme, StyleProps>((theme) =>
  createStyles({
    root: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      maxHeight: '100vh',
    },
    content: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      paddingTop: 72,
    },
    centered: {
      justifyContent: 'center',
      alignItems: 'center',
    },
    progress: {
      color: ({ primaryColor }) => `${primaryColor} !important`,
    },
  }),
);

export default useStyles;
